module.exports = __webpack_public_path__ + "fonts/2382fa8a8afcdbe3124c840bd6ef7024-Roboto-Light.ttf";